/**
 * Production-hostname gate, shared by the measurement layers (Google Ads
 * conversions in `ads.ts`, GA4 analytics in `analytics.ts`).
 *
 * There is a single production Google Ads account and a single GA4 property,
 * but the dev app (`remindmevoice-dev-app.web.app`) and local dev ship the same
 * code and tag ids. Without this gate, test activity would pollute real
 * conversion/analytics data (and, later, value-based bidding). So both layers
 * only ever send from the production hostnames.
 */
export const PROD_HOSTS = [
  'remindmevoice.com',
  'www.remindmevoice.com',
  'app.remindmevoice.com',
];

export function isProdHost(): boolean {
  return PROD_HOSTS.includes(window.location.hostname);
}
